var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20,15 L20,4 L4,4 L4,20 L15,20 L15,17 C15,15.8954305 15.8954305,15 17,15 L20,15 Z M19.5857864,17 L17,17 L17,19.5857864 L19.5857864,17 Z M4,22 C2.8954305,22 2,21.1045695 2,20 L2,4 C2,2.8954305 2.8954305,2 4,2 L20,2 C21.1045695,2 22,2.8954305 22,4 L22,17.4142136 L17.4142136,22 L4,22 Z M7,17 L7,15 L13,15 L13,17 L7,17 Z M7,13 L7,11 L17,11 L17,13 L7,13 Z M7,9 L7,7 L17,7 L17,9 L7,9 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteText);
export default __webpack_public_path__ + "static/media/note-text.afc599b287f409f5b803eedc3328e72d.svg";
export { ForwardRef as ReactComponent };